import { ToolTipDescription, ToolTipIcon } from './ToolTipWrapper.styles'

type Props = {
  children: React.ReactElement
  data: string | undefined
  disabled?: boolean
}

// TODO: Add a test for authenticated vs unauthenticated (see useAuthSession - process.env.MOCK_AUTH_SESSION)
const ToolTipWrapper = ({
  children,
  data,
  disabled = false,
}: Props): JSX.Element => {
  return (
    <>
      <ToolTipIcon disabled={disabled}>
        {children}
        <ToolTipDescription>{data}</ToolTipDescription>
      </ToolTipIcon>
    </>
  )
}
export default ToolTipWrapper
